import React, { Component } from 'react'
import Button from 'components/Button'
import BillingAccountField from 'features/Billing/BillingAccountField'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'

export default class BillingAccountLinkStep extends Component {
  componentDidMount() {
    const { setHeadings, headings } = this.props

    setHeadings &&
      setHeadings(
        headings || {
          heading: "Ok, now comes the fun part. Let's make magic happen!",
          subHeading:
            "Where would you like to have this billed? (Already with Pickle, we love simplicity. You can have this service added to your existing account. If you're new to Pickle or would like a new billing account, we can do that here too)",
        }
      )
  }

  render() {
    const { prev, loading, change, formData } = this.props

    return (
      <div>
        <div className={cn(sText.descrip3, sMarg.mb30)}>
          If you have an existing account with pickle simply select your billing account below.
          Don't have one, that's fine too, just hit set up a new account. Please Note: It may be
          helpful to create multiple billing accounts if you manage services for multiple locations
          or businesses or to help with marketing cost breakdowns etc...
        </div>
        <BillingAccountField change={change} />
        <div
          className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
          style={{ marginTop: '40px' }}
        >
          <Button
            color="tertiary"
            type="submit"
            loading={loading}
            disabled={!formData.ban || loading}
          >
            Next
          </Button>
          <br />
          <br />
          <Button plain onClick={prev}>
            Back
          </Button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountLinkStep/BillingAccountLinkStep.jsx